import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { RestriccionProductosExViewModel } from '../restriccionproductoex.types';
import { FormGroup } from '@angular/forms';
import { Tc, WBotanicaExtendedViewModel } from '../../../../core/_infrastructure/types/common';
import { PaisViewModel } from '../../../general/paises/pais.types';
import { DatePipe } from '@angular/common';
import { DialogComponent } from '../../../../core/components/dialog/dialog.component';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';

@Component({
    selector: 'app-restriccionproductoex-edit',
    templateUrl: './restriccionproductoex-edit.component.html',
})
export class RestriccionProductosExEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() restriccion: RestriccionProductosExViewModel;
    @Input() formGroup: FormGroup;
    @Input() listPais: Tc[];
    @Input() cloneMode = false;

    @ViewChild(DialogComponent) private dialogComponent: DialogComponent;
    dialogComponentVisible = false;

    isCollapsedCabecera = false;
    isCollapsedEspecie = false;
    dialogTitle = 'Selecciona la Especie para la Restricción';
    preSelection: WBotanicaExtendedViewModel | null = null;
    preSelectionPais: PaisViewModel | null = null;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        public datepipe: DatePipe,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.restriccion?.currentValue) {
            this.restriccion = { ...changes.restriccion.currentValue };
            this.updateForm();
        }
    }

    /**
     * This functions sets the values in the variedad (@Input) into the form.
     */
    private updateForm(): void {
        this.formGroup.patchValue({
            // Sección Datos de Restricción
            IdEspecie: this.restriccion?.IdEspecie || null,
            IdPaisDestino: this.restriccion?.IdPaisDestino || null,
            FechaCreacion: this.datepipe.transform(this.restriccion?.FechaCreacion, 'dd/MM/yyyy') || null,
            FechaBaja: this.datepipe.transform(this.restriccion?.FechaBaja, 'dd/MM/yyyy') || null,
            Activa: this.restriccion?.Activa || false,
            // Especie asociada
            IdGrupo: this.restriccion?.IdGrupo || null,
            IdGrupoDescripcion: this.restriccion?.IdGrupoDescripcion || '',
            IdForma: this.restriccion?.IdForma || null,
            IdFormaDescripcion: this.restriccion?.IdFormaDescripcion || '',
            NombreComun: this.restriccion?.NombreComun || '',
            NombreCientifico: this.restriccion?.NombreCientifico || '',
            CodigoEppo: this.restriccion?.CodigoEppo || '',
        });

        this.form = this.formGroup; // componentBase uses this.form
    }

    /**
     * When the dialog is opened, a component is injected on it and once data is selected
     * an event is emitted.
     * dblclick equals true: The event is captured and the values are assigned to the form. This event occurs when the user double-click a row in the table-list. The dialog is automatically closed.
     * dblclick equals false: The event is captured and the values are assigned to the preselection. This event occurs when the users clicks a row in the table-list. In this case the dialog must be explicitly closed by the user.
     * @param Object {
     *  selection WBotanicaExtendedViewModel Element selected in the component embedded in the dialog
     *  dblclick: boolean It indicates if the user has click the row or double-clicked.
     * }
     */
    onSelected(event$: any): void {
        const selection: WBotanicaExtendedViewModel = event$.selection;
        const selectionPais: PaisViewModel = event$.selection;

        const dblclick = event$.dblclick;

        if (!dblclick) {
            this.preSelection = selection;
            return;
        }
        this.dialogComponent.closeDialog();

        this.formGroup.patchValue({
            IdEspecie: selectionPais.Id,
            FechaCreacion: this.formGroup.value.FechaCreacion,
            FechaBaja: this.formGroup.value.FechaBaja,
            Activa: this.formGroup.value.Activa,
            // The following are read only but will be shown on screen.
            IdGrupo: selection.IdGrupo,
            IdGrupoDescripcion: selection.IdGrupoDescripcion,
            IdForma: selection.IdForma,
            IdFormaDescripcion: selection.IdFormaDescripcion,
            CodigoEppo: selection.CodigoEppo,
            NombreCientifico: selection.IdNombreCientificoDescripcion,
            NombreComun: selection.NombreComun,
        });
        this.formGroup.markAsDirty();
    }

    /**
     * When the user clicks in the button for searching an "Especie".
     */
    onSelectEspecie(): void {
        // Doing this we avoid the buscadorespecies-list to be initiated
        this.dialogComponentVisible = true;
        setTimeout(() => {
            // To give time so the dialog is initialized
            this.dialogComponent.showDialog();
        });
    }

    /**
     * When the user selects "Aceptar" in the dialog, 'accepted' will be true
     * If the user clicks "Cancelar", 'accepted' will be false, in this case the preselection is discarded.
     * @param accepted boolean
     */
    onDialogAccepted(accepted: boolean): void {
        if (!accepted) {
            this.preSelection = null;
            return;
        }
        this.onSelected({
            selection: this.preSelection,
            dblclick: true,
        });
    }

    get title(): string {
        if (!this.cloneMode) {
            return this.restriccion ? 'Editar' : 'Nueva';
        } else {
            return 'Clonar';
        }
    }
}
